import "./Pagination.css";

import { type FetchNextPageOptions } from "@tanstack/react-query";
import RcPagination, { type PaginationProps } from "rc-pagination";
import { memo, useEffect, useState } from "react";
import { useController, useFormContext } from "react-hook-form";

interface Props extends PaginationProps {
  className?: string;
  fetchNextPage?: (options?: FetchNextPageOptions) => void;
}

const Pagination = ({ fetchNextPage, pageSize = 20, ...rest }: Props) => {
  const { field } = useController({ name: "page", defaultValue: 1 });
  const [lastPageFetched, setLastPageFetched] = useState(1);
  const [isInit, setIsInit] = useState(false);
  const { watch } = useFormContext();
  const form = watch();

  const { page: currentPage, searchType, ...restForm } = form;

  useEffect(() => {
    if (field.value !== 1) {
      field.onChange(1);
    }
  }, [JSON.stringify(restForm)]);

  useEffect(() => {
    if (!isInit && rest.total) {
      document
        .querySelector(".rc-pagination-simple-pager input")
        ?.setAttribute("readonly", "true");
      setIsInit(true);
    }
  }, [rest.total]);

  const onChange = (page: number) => {
    if (lastPageFetched < page) {
      fetchNextPage?.();
      setLastPageFetched(page);
    }
    field.onChange(page);
  };

  if (!rest.total) {
    return null;
  }

  return (
    <div className="flex justify-center mt-auto pt-[0.625rem]">
      <RcPagination
        current={field.value}
        onChange={onChange}
        pageSize={pageSize}
        {...rest}
      />
    </div>
  );
};

export default memo(Pagination);
